import Base from "./base";

class Support extends Base {
  sendMessage(data) {
    return this.post(`support/contact-us`, data);
  }
}

export default new Support();
